<template>
    <div>
        <Tabs class="mt-5" :default-index="categories.findIndex((c) => c.id === activity.category_id)">
            <Tab :title="category.name" v-for="category in localCategories" :key="category.id">
                {{ category.name }}

                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <div class="sm:col-span-1" v-for="dimension in category.dimensions" :key="dimension.id">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{ dimension.abbreviation }} - {{ dimension.title }}
                        </label>
                        <ul class="m-3">
                            <li v-for="competence in dimension.competences" :key="competence.id" class="pt-4">
                                <div class="flex justify-between space-x-2">
                                    <div>
                                        {{ competence.abbreviation }}
                                    </div>
                                    <div>
                                        {{ competence.description }}
                                    </div>
                                </div>
                                <div class="text-sm">
                                    <FormInput
                                        type="number"
                                        v-model.number="competence.value"
                                        min="0"
                                        step="1"
                                        class="mt-1 inline-block"
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </Tab>
        </Tabs>

        <form :action="activity.links.update" method="post" @submit.prevent="submit" class="mt-5">
            <div class="flex justify-end">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="false" />
            </div>
        </form>
    </div>
</template>

<script>
import Tab from '@/components/Tab.vue';
import Tabs from '@/components/Tabs.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        Tab,
        Tabs,
        FormInput,
    },
    name: 'ActivityCompetencesSelector',
    props: {
        categories: { required: true, type: Array },
        activity: { required: true, type: Object },
    },
    data() {
        return {
            localCategories: this.categories,
        };
    },
    methods: {
        submit() {
            this.$inertia.patch(this.activity.links.update, {
                competences: this.selectedCompetences,
            });
        },
    },
    computed: {
        selectedCompetences: function () {
            return this.localCategories
                .flatMap((c) => c.dimensions)
                .flatMap((d) => d.competences)
                .filter((c) => c.value)
                .map((c) => ({ id: c.id, value: c.value }));
        },
    },
};
</script>
